<template>
  <div class="layout layout--default layout--padd">
    <Header />
    <HeaderBanner />
    <div class="search-header">
      <FieldsSearch
        class-name="search__field--banner"
        placeholder="Search Files, Tags, Topics and Content Types"
      />
    </div>
    <div class="u-width-wrapper">
      <div class="main-content">
        <SideBlock region="content_above" />
        <NuxtPage />
        <SideBlock region="content_below" />
      </div>
      <Sidebar />
    </div>
    <Footer />
  </div>
</template>
<style lang="scss" scoped>
  .u-width-wrapper {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .search-header {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-top: 3rem;
    padding-bottom: 5rem;
  }
</style>
